import React__default from 'react';
import styles from './911805e7d0f3f24d5c4539dfbcbf0ca9410ef311f2044b4b999baa91b0b8e88b.cfe-internal.js';
import '../629495c61f6f3ffdfe2248a13b452d018cea8d55bb88c94e497bf6f5395fc2fd.cfe-internal.js';
import Pagination from '../Pagination/a6419580327c1da4cf5ebf188725ed9bf5c4befd1fe937238d81ccab1cfc1479.cfe-internal.js';

/* eslint-disable no-nested-ternary */
var AdvancedTablePagination = function AdvancedTablePagination(_ref) {
  var rowsPerPage = _ref.rowsPerPage,
    currentPage = _ref.currentPage,
    setCurrentPage = _ref.setCurrentPage,
    rows = _ref.rows,
    ariaLabel = _ref.ariaLabel,
    onPageChange = _ref.onPageChange;
  var handlePageChange = function handlePageChange(_ref2) {
    var page = _ref2.page;
    setCurrentPage(page);
    onPageChange === null || onPageChange === void 0 || onPageChange(page);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.advancedTablePaginationContainer
  }, /*#__PURE__*/React__default.createElement(Pagination, {
    className: styles.advancedTablePagination,
    "aria-label": ariaLabel,
    numPages: Math.max(Math.ceil(rows.length / rowsPerPage), 1),
    currentPage: currentPage,
    onPageChange: handlePageChange
  }));
};

export { AdvancedTablePagination as default };
